import { ChangeEvent } from 'react'
import { AddressSuggestions, DaDataAddress } from 'react-dadata'
import { CommonProps, DaDataSuggestion } from 'react-dadata/dist/core-types'
import { Controller } from 'react-hook-form'
import { DADATA_TOKEN } from '~/shared/config/env'
import { InputWrapper, Label, ErrorMessage } from './styled'
import 'react-dadata/dist/react-dadata.css'

export type CustomDaDataSuggestion<T extends object> = {
  value: string
  unrestricted_value: string
  data: T
}

type DaDataInputProps<T extends object> = {
  name: string
  label: string
  onSelected?: (suggestion?: CustomDaDataSuggestion<T>) => void
  renderOption?: (suggestion?: CustomDaDataSuggestion<T>) => void
  onMappedSelectedValue?: (
    suggestion?: CustomDaDataSuggestion<T>,
  ) => string | undefined
} & Omit<Partial<CommonProps<DaDataAddress>>, 'renderOption'>

export function DaDataInput<T extends object>({
  label,
  name,
  onSelected,
  renderOption,
  onMappedSelectedValue,
  ...props
}: DaDataInputProps<T>) {
  const handleSelected = (suggestion?: DaDataSuggestion<DaDataAddress>) => {
    onSelected?.(suggestion as CustomDaDataSuggestion<T>)
  }

  const handleMappedSelected = (
    suggestion?: DaDataSuggestion<DaDataAddress>,
  ) => {
    return onMappedSelectedValue
      ? onMappedSelectedValue(suggestion as CustomDaDataSuggestion<T>)
      : suggestion?.value
  }

  const handleRenderOption = (suggestion?: DaDataSuggestion<DaDataAddress>) => {
    return renderOption?.(suggestion as CustomDaDataSuggestion<T>) || ''
  }
  return (
    <Controller
      name={name}
      defaultValue=''
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => {
        return (
          <InputWrapper
            $invalid={invalid}
            $filled={Boolean(value)}
            data-testid={`input-wrapper-${name}`}
          >
            <AddressSuggestions
              token={DADATA_TOKEN}
              value={{ value } as DaDataSuggestion<DaDataAddress>}
              filterLanguage='ru'
              delay={400}
              httpCache
              onChange={(suggestion?: DaDataSuggestion<DaDataAddress>) => {
                handleSelected(suggestion)
                const mappedValue = handleMappedSelected(suggestion)

                onChange(mappedValue)
              }}
              inputProps={{
                name,
                onInput: (e: ChangeEvent<HTMLInputElement>) => {
                  onChange(e.target.value)
                },
              }}
              {...(renderOption ? { renderOption: handleRenderOption } : {})}
              {...props}
            />
            <Label>{label}</Label>

            {invalid && (
              <ErrorMessage data-testid='error-message'>
                {error?.message || 'Обязательное поле'}
              </ErrorMessage>
            )}
          </InputWrapper>
        )
      }}
    />
  )
}
